import styled from '@emotion/styled';
import axios from 'axios';
import RulesIcon from 'components/orders/order-information/RulesIcon';
import Button from 'components/ui/Button';
import ConfirmActionModal from 'components/ui/ConfirmActionModal';
import { XIconLarge } from 'components/ui/icons';
import TextField from 'components/ui/TextField';
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Loader } from 'semantic-ui-react';
import Documents from './Documents';
import ErrorModal from './ErrorModal';
import MainOrderDetails from './MainOrderDetails';
import { useOrderEntry } from './OrderEntryContext';
import PropertiesAndNames from './PropertiesAndNames';
import Searches from './Searches';
import { Property } from './types';

const OrderEntryLayout = styled.div`
  margin-left: -40px;
  margin-right: -40px;
`;
const NewOrderButton = styled.button`
  height: 48px;
  background-color: #ff5252;
  border-radius: 5px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  color: #ffffff;
  padding: 0 8px;
`;
const CloseButton = styled.div`
  align-items: center;
  background-color: #f7f7f9;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  height: 56px;
  width: 56px;
  justify-content: center;
  color: #333;
  position: absolute;
  right: 100px;
  :hover {
    svg: {
      color: #ff5252;
    }
  }
`;
const OrderEntry = () => {
  const {
    selectedClient,
    submitOrder,
    submitting,
    setOpenSellerErrorModal,
    openSellerErrorModal,
    contactEmailReceiver,
    setContactEmailReceiver,
    searchesAssignObj,
    openYonkersCommercialModal,
    setOpenYonkersCommercialModal,
    properties,
  } = useOrderEntry();

  const [modalText, setModalText] = useState('');
  const [modalHeight, setModalHeight] = useState(400);

  useEffect(() => {
    if (
      Object.keys(searchesAssignObj).length > 0 &&
      properties.find(p => p.selectedCity?.municipality === 'Yonkers')
    ) {
      setUpYonkersModal();
    }
  }, [Object.keys(searchesAssignObj).length > 0, properties.length]);

  const setUpYonkersModal = () => {
    var commercialPropertiesText = '';
    const propertiesInYonkers = properties.filter(p => p.selectedCity?.municipality === 'Yonkers');
    const propertiesWithBuildingClass: Property[] = [];
    const unvalidatedProperties: Property[] = [];
    propertiesInYonkers.forEach(p => {
      if (p.buildingCode) {
        propertiesWithBuildingClass.push(p);
      } else {
        unvalidatedProperties.push(p);
      }
    });

    const commercialProperties = propertiesWithBuildingClass.filter(p => p.buildingCode.charAt(0) !== '2');

    commercialPropertiesText = commercialProperties.length
      ? commercialProperties.length >= 3
        ? 'Some properties on this order are commercial.'
        : `The following are commercial properties:\n${commercialProperties
            .map(p => {
              return `• ${p.address} (${p.section}-${p.block}-${p.lot})\n    Building Code ${p.buildingCode}${['411', '437'].includes(p.buildingCode) ? ' (Condo)' : ''}`;
            })
            .join('\n')}`
      : '';

    const unvalidatedPropertiesText = unvalidatedProperties.length
      ? 'Reminder - All unvalidated properties must be checked to see if they are commercial.'
      : '';

    const betweenText = commercialPropertiesText.length && unvalidatedPropertiesText.length ? '\n\n' : '';
    setModalText(`${commercialPropertiesText}${betweenText}${unvalidatedPropertiesText}`);

    const height =
      commercialProperties.length && commercialProperties.length < 3 && unvalidatedPropertiesText.length
        ? 400
        : (commercialProperties.length && commercialProperties.length < 3) ||
          (commercialProperties.length >= 3 && unvalidatedPropertiesText.length)
        ? 320
        : 260;
    setModalHeight(height);

    setOpenYonkersCommercialModal(commercialPropertiesText.length > 0 || unvalidatedProperties.length > 0);
  };

  return (
    <OrderEntryLayout>
      {/* <div style={{display: 'flex', justifyContent: 'right', marginRight: 50}}>
        <Link to="/orders/new-order">
          <NewOrderButton style={{backgroundColor:'#444'}}>Legacy Order Entry</NewOrderButton>
        </Link>
      </div> */}
      <Link to="/orders">
        <CloseButton>
          <XIconLarge />
        </CloseButton>
      </Link>
      {selectedClient?.value > 0 && (
        <div style={{ height: 41, width: 39, position: 'relative', top: 73, left: 1150 }}>
          <RulesIcon
            padding={'4px 4px 0px 3px'}
            clientId={selectedClient.value}
            backgroundColor={'#f9d0d0'}
          />
        </div>
      )}
      <MainOrderDetails />
      <PropertiesAndNames />
      <ErrorModal
        buttonText="Ok"
        info="There are no names entered on this order, please leave a note for the searcher."
        onClose={() => setOpenSellerErrorModal(false)}
        open={openSellerErrorModal}
      />
      <Searches />
      <Documents />
      <div style={{ marginLeft: 150 }}>
        <TextField
          value={contactEmailReceiver}
          onChange={e => setContactEmailReceiver(e.target.value)}
          width="296px"
          label="Order Contact"
        />
      </div>
      <div
        style={{ width: 1160, display: 'flex', justifyContent: 'flex-end', marginBottom: 32, marginTop: 32 }}
      >
        <Button disabled={submitting} onClick={submitOrder} black overRidestyle={{ width: 208 }}>
          {submitting ? <Loader inline size="small" active /> : 'Save Order'}
        </Button>
      </div>
      {openYonkersCommercialModal && (
        <ConfirmActionModal
          height={modalHeight}
          openState={openYonkersCommercialModal}
          onClose={() => setOpenYonkersCommercialModal(false)}
          header={'Yonkers Commercial Properties'}
          headerSymbol={'!'}
          info={modalText}
          actionFunction={() => setOpenYonkersCommercialModal(false)}
          buttonText={'Close'}
          hideSecondaryButton={true}
        />
      )}
    </OrderEntryLayout>
  );
};

export default OrderEntry;
